import { IMAGES } from "@/lib/site";

const PILLARS = [
  {
    title: "Fixed Transparent Pricing",
    body: "The price quoted is the price paid. No traffic meters, toll shocks, or terminal drop fees added.",
    img: IMAGES.feature1,
    tag: "Fixed Fare Guarantee",
  },
  {
    title: "Live Flight Tracking",
    body: "We monitor tail numbers in real time. Land two hours late and your chauffeur is waiting calmly.",
    img: IMAGES.feature2,
    tag: "Live Tail Tracking",
  },
  {
    title: "Licensed Chauffeurs",
    body: "Local executive drivers fully vetted with airport terminal fast-track clearances.",
    img: IMAGES.feature3,
    tag: "Executive Class",
  },
  {
    title: "Instant Stripe Checkout",
    body: "Secure card settlement in seconds. Instant booking voucher delivered directly to your inbox.",
    img: IMAGES.feature4,
    tag: "Instant Payment",
  },
];

export const Pillars = () => (
  <section id="guarantee" className="scroll-mt-20 border-b border-white/10 py-24" data-testid="pillars-section">
    <div className="mx-auto max-w-6xl px-6">
      <div className="mb-16 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <span className="font-mono-lbl text-xs uppercase tracking-widest text-[#38bdf8]">The Four Pillars</span>
          <h2 className="mt-2 font-disp text-4xl uppercase text-white md:text-5xl">Why Holidaymakers Choose EL &amp; MJ</h2>
        </div>
        <p className="max-w-sm text-sm text-slate-400">No surge meters or late gate stress. Everything booked and locked prior to takeoff.</p>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <div
            key={p.title}
            data-testid={`pillar-card-${i + 1}`}
            className="group flex flex-col justify-between rounded-2xl border border-white/10 bg-white/5 p-6 transition-colors hover:border-[#38bdf8]/50"
          >
            <div>
              <h3 className="mb-2 font-disp text-xl uppercase text-white">{p.title}</h3>
              <p className="text-xs leading-relaxed text-slate-400">{p.body}</p>
            </div>
            <div className="relative mt-6 h-32 overflow-hidden rounded-xl border border-white/10">
              <img src={p.img} alt={p.tag} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-black/30"></div>
              <div className="absolute bottom-2 left-2 font-mono-lbl text-[10px] uppercase text-slate-200">{p.tag}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
